// DateRangeFilter.js
// import { ORDER_FILTER_KEYS } from '../Filter';
import { Box, List, ListItem, ListItemButton, useTheme } from '@mui/material';
import { tokens } from '../../../../../theme';
import { orderStateMap } from '../../../../../utils/labelColorText';
import { ORDER_FILTER_KEYS } from '../../Filter';
import { useTranslation } from 'react-i18next';
import { useState } from 'react';
import cx from 'classnames'; // Importing cx from classnames
import { useDispatch, useSelector } from 'react-redux';
import { useGridFilter } from '../../../../../contexts/GridFilterContext';
import { updateFilter } from '../../../../../newapi/global/filter/gridFilterSlice';
import { useGetOptionsWithCountQuery } from '../../../../../newapi/pickingjob/pickingjobSlice';
import Text from '../../../../theme/text/Text';
import CheckIcon from '@mui/icons-material/Check';

const StreamFilter = ({ params }) => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const {t} = useTranslation();
    const filterKey = ORDER_FILTER_KEYS.STREAM.backend_key;
    const dispatch = useDispatch();

    const { index,id } = useGridFilter();
    const filterObject = useSelector((state) => {
        const instance = state.gridFilter.viewInstances[index];
        return instance ? instance[id] : undefined;
    });

    // console.log(filterObject);
    const states = filterObject.filter?.state || [];

    let urlquery =
        states.length > 0
            ? `&states=${states.join(',')}`
            : '';
    
    if (params?.postponed) {
        urlquery += "&postponed=true";
    }

    if (params?.ignorecount) {
        urlquery += "&ignorecount=true";
    }
    
    const {data, isLoading, isFetching} = useGetOptionsWithCountQuery({
        type:'stream',
        urlquery
    });

    // const allStates = Object.values(orderStateMap(theme));
    const handleStateToggle = (itemState) => {
        if (filterObject && filterObject.filter) {
            const currentState = filterObject.filter[filterKey] ?? -1;

            const updatedState = (currentState === itemState) ? -1 : itemState;
            // const currentStates = filterObject.filter[filterKey] || [];

            // // Check if the clicked labeltext is already in the backendKey (active states)
            // const updatedStates = currentStates.includes(itemState)
            //     ? currentStates.filter(state => state !== itemState) // Remove if already active
            //     : [...currentStates, itemState]; // Add if not active

            // Dispatch the action to update the filter with the new active states
            dispatch(updateFilter({ index, id, filterKey, value: updatedState }));
        }
    };
  
    return (
        <Box
            sx={{
                display:"flex",
                flexDirection:"column",
                gap:1.5,
            }}
        >
                    <List
                        sx={{
                            padding:0,
                            display:"flex",
                            flexDirection:"column",
                            gap:1.5,
                        }}
                    >
                    {data?.data?.map((column, index) => (

                        <ListItem key={column.name + "index"} disablePadding 
                            onClick={() => handleStateToggle(column.id)}
                        >
                            <ListItemButton
                                className={cx({
                                    active: filterObject && filterObject.filter?.[filterKey] === column.id
                                })}
                                sx={{
                                    minWidth:250,
                                    color:`${filterObject.sortedBy.length > 0 && filterObject.sortedBy[0].column === column.name ? theme.palette.mode === "dark" ? colors.blue[400] : colors.primary[400] : colors.txt["secondary"]}`,
                                    fontWeight:`${filterObject.sortedBy.length > 0 && filterObject.sortedBy[0].column === column.name ? 500 : 400}`,
                                    display:"flex",
                                    justifyContent:"space-between",
                                    fontSize:"14px",
                                    pl:2,
                                    pr:0.5,
                                    height:40,
                                    borderRadius:5,

                                    background:theme.palette.mode === "dark" ? colors.grey[500] : colors.grey[0],
                                    border: theme.palette.mode === "dark" ? null : `1px solid ${colors.grey[100]}`,
                                    boxShadow:theme.palette.mode === "dark" ? null :  `0px 2px 4px ${colors.grey[200]}`,
                                    "&.active" : {
                                        background:theme.palette.mode === "dark" ? colors.blue[100] : colors.primary[100],
                                        color:theme.palette.mode === "dark" ? colors.blue[400] : colors.primary[400],

                                    }
                                }}
                            >
                                <Text>{column.name}</Text>

                                <Box
                                    sx={{
                                        display:"flex",
                                        alignItems:'center',
                                        gap:1,
                                    }}
                                >
                                    <Box
                                        className={cx({
                                            active: filterObject && filterObject.filter?.[filterKey] === column.id
                                        })}
                                        sx={{
                                            height:32,
                                            minWidth:32,
                                            display:"none",
                                            
                                            color:theme.palette.mode === "dark" ? colors.blue[400] : colors.primary[400],
                                            "&.active": {
                                                display:'flex',
                                                alignItems:'center',
                                                justifyContent:'center',
                                            }
                                        }}
                                    >
                                        <CheckIcon fontSize="small"/>

                                    </Box>
                                    {!params?.ignorecount && (
                                    <Box
                                        className={cx({
                                            active: filterObject && filterObject.filter?.[filterKey] === column.id
                                        })}
                                        sx={{
                                            height:32,
                                            minWidth:32,
                                            px:1,
                                            background:theme.palette.mode === "dark" ? colors.grey[800] : colors.grey[100],
                                            display:'flex',
                                            alignItems:'center',
                                            justifyContent:'center',
                                            borderRadius:4,
                                            "&.active" : {
                                                background:theme.palette.mode === "dark" ? colors.blue[100] : colors.primary[100],
                                                color:theme.palette.mode === "dark" ? colors.blue[400] : colors.primary[400],
        
                                            }
                                        }}
                                    >
                                        <Text>{column.count}</Text>


                                    </Box>
                                    )}
                                </Box>

                                {/* {filterObject.sortedBy.length > 0 && filterObject.sortedBy[0].column === column.column
                                    ?
                                    <CheckIcon fontSize="small"/>
                                    :
                                    null
                                } */}
                            </ListItemButton>
                        </ListItem>
                        
                    ))}
                </List>
            {/* Stream */}
            {/* {allStates.map((stateData,index) => {
                return (
                    <Box
                        className={cx({
                            active: filterObject && filterObject.filter?.[filterKey]?.includes(stateData.state), // Add the 'active' class if state is active
                        })}
                        onClick={(
                            
                        ) => handleStateToggle(stateData.state)}
                        key={index + stateData.labeltext}
                        sx={{
                            height:40,
                            border: `1px solid ${theme.palette.mode === "dark" ? colors.grey[400] :colors.grey[100]}`,
                            p:0.5,
                            borderRadius:5,
                            display:"flex",
                            alignItems:'center',
                            "&.active " : {
                                background: colors[stateData.labelcolor][100],
                                border: `1px solid ${colors[stateData.labelcolor][100]}`,
                            }
                        }}
                    >
                        <Box
                            sx={{
                                height:32,
                                background: colors[stateData.labelcolor][100],
                                color: colors[stateData.labelcolor][400],
                                fontFamily:"Roboto, sans-serif",
                                fontSize:14,
                                fontWeight:500,
                                display:"inline-flex",
                                minWidth:120,
                                alignItems:"center",
                                justifyContent:"center",
                                borderRadius:4,
                            }}
                        >
                            {t(stateData.labeltext)}
                        </Box>

                    </Box>
                );
            })} */}
            
        </Box>
    );
};

export default StreamFilter;

// StreamDisplayData moved to its own module so non-filter importers (e.g. dashboard cards) don't pull in
// Filter.js (a circular import). Re-exported here to preserve the existing import path.
export { StreamDisplayData } from './StreamDisplayData';
